import * as React from "react";

const ArrowRight = ({
  width = 16, // Default size
  height = 16,
  color = "#ffffff",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 19 16"
    fill="none"
    stroke={color}
    {...props}
  >
    <g id="Group 48099358">
      <g id="Group 48099189">
        <g id="Group 48099263">
          <path
            id="Line_316_arrow_left"
            d="M1 7.91907L18 7.91907"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
          />
          <path
            id="Line_317_arrow_left"
            d="M11.271 1.27179L17.8596 7.86042"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
          />
          <path
            id="Line_318_arrow_left"
            d="M11.271 14.4493L17.8596 7.86065"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowRight;

